<template>
  <div class="empty-layer-container">
    <div class="left-controls vh-100 d-flex f-column p-relative">
      <router-link to="/" class="logo-sm d-block">
        <svg id="Group_2445" data-name="Group 2445" xmlns="http://www.w3.org/2000/svg" width="50" height="51.24"
          viewBox="0 0 50 51.24">
          <path id="Path_14062" data-name="Path 14062"
            d="M15359.1,2836.146h10.182v-13.957h13.066v13.957h10.177V2792.63h-10.177v20.533H15359.1Z"
            transform="translate(-15342.526 -2784.906)" fill="#fefefc" />
          <path id="Path_14063" data-name="Path 14063"
            d="M15076.42,2645.32h-10.177v13.957h-13.066V2645.32H15043v43.516h10.177V2668.3h23.243Z"
            transform="translate(-15043 -2645.32)" fill="#ca9760" />
        </svg>
      </router-link>
      <div class="language-control">
        <Language />
      </div>
      <div class="call-control mt-auto">
        <span>Обратный звонок</span>
        <p class="m-0 text-white">+998 71 233 33 30</p>
      </div>
    </div>
    <div class="layer-control-text">
      <div class="page-content__meta d-flex f-between">
        <h1 class="page-title">Выбор объекта</h1>
      </div>
    </div>
    <BottomNavigation />
    <TheNavigationMenu />
    <div class="object-area-view">
      <div class="object-area p-absolute w-100 vh-100">
        <div class="object-background h-100" v-touch:swipe.left="swipeHandler" v-touch:swipe.right="swipeHandler"
          v-touch-options="{
            touchClass: 'grabbing',
            swipeTolerance: 30,
            touchHoldTolerance: 300,
          }">
          <div class="object-svg p-relative vh-100">
            <div class="object-svg__container p-absolute hidden" ref="swipeContainer">
              <img :src="activeObject.house_img" alt="Object Image" class="d-block" />
              <div class="area-layer p-absolute w-100 h-100"></div>
              <div style="top: 0" class="object-svg-wrap p-absolute" v-html="activeObject.house_svg"></div>
            </div>

            <div class="object-svg__number rounded p-absolute text-center" ref="svgFlatNumber"></div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="this.$route.fullPath == '/apartment-selection/3/1' || this.$route.fullPath == '/apartment-selection/1/1' || this.$route.fullPath == '/apartment-selection/1/2' || this.$route.fullPath == '/apartment-selection/1/3' || this.$route.fullPath == '/apartment-selection/1/4' || this.$route.fullPath == '/apartment-selection/1/5'">
      <router-link :to="{ name: 'Slider' }" class="galireya">Галерея</router-link>
    </div>
    <!-- <div v-if="this.$route.fullPath == '/apartment-selection/1/1'">
      <router-link :to="{ name: 'Slider' }" class="galireya">Галерея</router-link>
    </div> -->
  </div>
</template>

<script>
import TheNavigationMenu from "../../components/layout/TheNavigationMenu";
import BottomNavigation from "./components/BottomNavigation";
import Language from "../../components/Language";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      // swipeGap: 250,
      // swipeCountX: 0,
      activeObject: {}
    };
  },
  computed: {
    ...mapGetters({
      list: "projects/projects",
    })
  },
  components: {
    TheNavigationMenu,
    Language,
    BottomNavigation
  },
  created() {
    const project_id = this.$route ? +this.$route.params.project : null;
    const pr = this.list.find(function (item) {
      return project_id == item.id;
    });

    const house_id = this.$route ? parseInt(this.$route.params.house) : null;
    this.activeObject = pr.houses.find(item => {
      return house_id == item.id;
    });
  },
  mounted() {
    const { svgFlatNumber } = this.$refs;

    let _hoverTarget = document.querySelectorAll(".object-svg-use");

    _hoverTarget.forEach((el, index) => {
      el.addEventListener("mousemove", function (e) {
        svgFlatNumber.classList.add("active");
        svgFlatNumber.style.top = `${e.offsetY - 175}px`;
        svgFlatNumber.style.left = `${e.offsetX - 75}px`;
        svgFlatNumber.textContent = el.dataset["floor"];
      });

      el.addEventListener("mouseout", function () {
        svgFlatNumber.classList.remove("active");
      });
    });

  },
  methods: {
    swipeHandler(direction) {
      const { swipeContainer } = this.$refs;
      // const swipeImage = swipeContainer.children[0];
      // const _bodyWidth = document.querySelector("body").clientWidth;
      // const _bodyHeight = document.querySelector("body").clientHeight;

      // if (direction === "left") {
      //   this.swipeCountX = this.swipeCountX + this.swipeGap;
      // } else if (direction === "right") {
      //   this.swipeCountX = this.swipeCountX - this.swipeGap;
      // }
      // if (this.swipeCountX < 0) {
      //   this.swipeCountX = 0;
      // }
      // if (swipeImage.naturalWidth - _bodyWidth < this.swipeCountX) {
      //   this.swipeCountX = swipeImage.naturalWidth - _bodyWidth;
      // }

      // swipeContainer.style.transform = `translateX(${-this.swipeCountX}px)`;
    }
  }
};
</script>

<style>
.galireya {
  position: absolute;
  /* background: red; */
  top: 80px;
  margin: auto;
  right: 100px;
  /* width: 100px; */
  text-align: center;
  z-index: 9999;
  color: #ffffff;
  font-weight: 700;
  font-size: 21px;
  border: 1px solid #b6896026;
  padding: 5px 20px;
  background-color: #ca9760;
}
</style>
